/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const sectionInfo = [
    {
      sectionName: "CORE.MENUSECTION.CORE",
      icon: "/media/svg/icons/Home/Library.svg",
      path: "/core",
    },
    {
      sectionName: "CORE.MENUSECTION.ADMINISTRATION",
      icon: "/media/svg/icons/General/Duplicate.svg",
      path: "/inspection",
    },
    {
      sectionName: "CORE.MENUSECTION.EDI",
      icon: "/media/svg/icons/Communication/Outgoing-box.svg",
      path: "/rundown",
    },
    {
      sectionName: "CORE.MENUSECTION.FMSDOT",
      icon: "/media/svg/icons/Home/Commode2.svg",
      path: "/fms",
    },
    {
      sectionName: "CORE.MENUSECTION.TPMS",
      icon: "/media/svg/icons/Shopping/Box3.svg",
      path: "/fms",
    },
    {
      sectionName: "CORE.MENUSECTION.RUNDOWN",
      icon: "/media/svg/icons/Communication/Clipboard-check.svg",
      path: "/rundown",
    },
    {
      sectionName: "CORE.MENUSECTION.INSPECTION",
      icon: "/media/svg/icons/Devices/Display3.svg",
      path: "/inspection",
    },
  ];

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const modules = useSelector(({ auth }) => auth.user.modules, shallowEqual);
  const sections = useSelector(
    ({ auth }) => auth.user.menuSections,
    shallowEqual
  );
  const objectTypesCrud = useSelector(
    ({ auth }) => auth.user.objectTypesCrud,
    shallowEqual
  );

  useEffect(() => {
    return () => {};
  }, [modules, objectTypesCrud, sections]);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", true)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">
              <FormattedMessage id="MENU.DASHBOARD" />
            </span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Log Events */}
        <li
          className={`menu-item ${getMenuItemActive("/logs", true)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/logs">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")}
              />
            </span>
            <span className="menu-text">
              <FormattedMessage id="MENU.LOGS" />
            </span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/user-profile", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/user-profile">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Add-user.svg"
                )}
              />
            </span>
            <span className="menu-text">
              <FormattedMessage id="ASIDE.MENU.USER.PROFILE" />
            </span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Applications */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">
            <FormattedMessage id="ASIDE.MENU.MODULES" />
          </h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end:: section */}

        {/* begin::  menu */}
        {sections.map((section) => {
          if (section.menuItems.length > 0) {
            return (
              <li
                key={section.name}
                className={`menu-item menu-item-submenu`}
                // className={`menu-item menu-item-submenu ${getMenuItemActive(
                //   moduleInfo.find((x) => x.moduleCode === module.code).path,
                //   false
                // )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to={
                    sectionInfo.find((x) => x.sectionName === section.name).path
                  }
                >
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        sectionInfo.find((x) => x.sectionName === section.name)
                          .icon
                      )}
                    />
                  </span>
                  <span className="menu-text">
                    <FormattedMessage id={section.name} />
                  </span>
                </NavLink>
                {/* begin:: section submenu */}
                <div className="menu-submenu">
                  <i className="menu-arrow" />
                  <ul className="menu-subnav">
                    <li
                      className="menu-item menu-item-parent"
                      aria-haspopup="true"
                    >
                      <span className="menu-link">
                        <span className="menu-text">
                          <FormattedMessage id={section.name} />
                        </span>
                      </span>
                    </li>
                    {section.menuItems.map((item) => (
                      <li
                        key={item.urlFrontEnd}
                        className={`menu-item ${getMenuItemActive(
                          item.urlFrontEnd,
                          false
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to={item.urlFrontEnd}>
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            <FormattedMessage id={item.name} />
                          </span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* begin:: section submenu */}
              </li>
            );
          } else {
            return null;
          }
        })}
        {/* end:: menu */}
      </ul>
      {/* end::Menu Nav */}
    </>
  );
}
